import axios from "axios";
import isEmpty from "lodash/isEmpty";

import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../shared/vars";

// ===================================
//  LOGIN
// ===================================
export const userLoginTokenLoading = userType => {
	return {
		type: "USER_LOGIN_TOKEN_LOADING",
		userType
	};
};

export const setUserLoginToken = (token, userType, maxLoginsReached) => {
	return {
		type: "USER_LOGIN_TOKEN_SET",
		userType,
		token,
		maxLoginsReached
	};
};

export const updateUserLoginMax = (maxLoginsReached, userType) => {
	return {
		type: "UPDATE_USER_MAX_LOGIN",
		userType,
		maxLoginsReached
	};
};

export const userLoginLoading = userType => {
	return {
		type: "USER_LOGIN_LOADING",
		userType
	};
};

export const userLoginError = (err, userType) => {
	return {
		type: "USER_LOGIN_ERROR",
		err,
		userType
	};
};

export const userLoginSuccess = (payload, userType) => {
	return {
		type: "USER_LOGIN_SUCCESS",
		payload,
		userType
	};
};

export function getCustomerLoginToken() {
	return (dispatch, getState) => {
		dispatch(userLoginTokenLoading("customer"));

		// console.log(getState().user.loginTokens);

		const token = !!getState().user.loginTokens["customer"]
			? getState().user.loginTokens["customer"]
			: "";
		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };

		const data = {
			type: "customer"
		};
		// console.log("here is the value for getcustomerlogintoken", token);
		return axios
			.get(REACT_APP_API_URL + "customer/login-token", { headers: AUTH_HEADER, params: data })
			.then(response => {
				// Error explicitly set
				if (!isEmpty(response.data.errors)) {
					dispatch(userLoginError(response.data.errors, "general"));
					return Promise.resolve();

					// Error status
				} else if (response.data.status !== 200) {
					dispatch(userLoginError(response.data.message, "general"));
					return Promise.resolve();

					// Success
				} else {
					// console.log("i made it ot sucess displatch setuserlogintoken");
					dispatch(
						setUserLoginToken(
							response.data.token,
							"customer",
							response.data.maxLoginsReached
						)
					);
					return Promise.resolve(response.data);
				}
			})
			.catch(err => {
				console.log("customerLogin error", err);
				dispatch(userLoginError(err.response.data.message, "guest"));
				return Promise.resolve();
			});
	};
}

export function customerLogin(email, password, recaptcha) {
	return (dispatch, getState) => {
		dispatch(userLoginLoading("customer"));

		const token = getState().user.loginTokens["customer"];
		// console.log("here is the value for the token variable", token);
		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };

		let data = {
			email,
			password
		};

		if (recaptcha) {
			data.recaptcha = recaptcha;
		}
		// console.log("here is the value for the data object", data);

		return axios
			.post(REACT_APP_API_URL + "customer/login", data, { headers: AUTH_HEADER })
			.then(response => {
				// Error explicitly set
				if (!isEmpty(response.data.errors)) {
					dispatch(userLoginError(response.data.errors, "customer"));
					dispatch(updateUserLoginMax(response.data.maxLoginsReached, "customer"));
					return Promise.reject(response.data.errors);

					// Error status
				} else if (response.data.status !== 200) {
					dispatch(userLoginError(response.data.message, "customer"));
					dispatch(updateUserLoginMax(response.data.maxLoginsReached, "customer"));
					return Promise.reject(response.data.message);

					// Success
				} else {
					dispatch(userLoginSuccess(response.data, "customer"));
					return Promise.resolve(response.data);
				}
			})
			.catch(err => {
				dispatch(userLoginError(err, "customer"));
				return Promise.reject();
			});
	};
}

export function guestLogin(email) {
	return dispatch => {
		dispatch(userLoginLoading("guest"));

		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY };

		const data = {
			email: email
		};

		return axios
			.post(REACT_APP_API_URL + "guest/login", data, { headers: AUTH_HEADER })
			.then(response => {
				// Error explicitly set
				if (!isEmpty(response.data.errors)) {
					dispatch(userLoginError(response.data.errors, "guest"));
					return Promise.resolve();

					// Error status
				} else if (response.data.status !== 200) {
					dispatch(userLoginError(response.data.message, "guest"));
					return Promise.resolve();

					// Success
				} else {
					dispatch(userLoginSuccess(response.data, "guest"));
					return Promise.resolve(response.data);
				}
			})
			.catch(err => {
				console.log("customerLogin error", err);
				dispatch(userLoginError(err.response.data.message, "guest"));
				return Promise.resolve();
			});
	};
}

export function adminLogin(username, password) {
	return dispatch => {
		dispatch(userLoginLoading("admin"));

		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY };

		const data = {
			username: username,
			password: password
		};

		return axios
			.post(REACT_APP_API_URL + "user/login", data, { headers: AUTH_HEADER })
			.then(response => {
				// Error explicitly set
				if (!isEmpty(response.data.errors)) {
					dispatch(userLoginError(response.data.errors, "admin"));
					return Promise.resolve();

					// Error status
				} else if (response.data.status !== 200) {
					dispatch(userLoginError(response.data.message, "admin"));
					return Promise.resolve();

					// Success
				} else {
					dispatch(userLoginSuccess(response.data, "admin"));
					return Promise.resolve(response.data);
				}
			})
			.catch(err => {
				console.log("adminLogin error", err);
				dispatch(userLoginError(err.response.data.message, "admin"));
				return Promise.resolve();
			});
	};
}

export function userCheckLogin(type) {
	return (dispatch, getState) => {
		// console.log(type, getState().user[type])

		// If user is not set
		if (!getState().user[type]) {
			dispatch(userExpiryChecked(type));
			return Promise.resolve();
		}

		const token = getState().user[type].token;
		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };

		return axios
			.get(REACT_APP_API_URL + "user/expired", { headers: AUTH_HEADER })
			.then(response => {
				// User expired
				if (response.data.expired) {
					dispatch(userLogout(type));

					// New user token
				} else {
					dispatch(userLoginSuccess(response.data, type));
				}

				// Set user checked
				dispatch(userExpiryChecked(type));
				return Promise.resolve();
			})
			.catch(err => {
				dispatch(userLogout(type));
				dispatch(userExpiryChecked(type));
			});
	};
}

// ===================================
//  LOGOUT
// ===================================
export const userLogout = userType => {
	return {
		type: "USER_LOGOUT",
		userType
	};
};

// ===================================
//  MISC
// ===================================
export const clearErrors = () => {
	return {
		type: "CLEAR_ERRORS"
	};
};

export const userExpiryChecked = userType => {
	return {
		type: "EXPIRY_CHECKED",
		userType
	};
};

export const userTokenUpdate = (userType, token) => {
	return {
		type: "USER_TOKEN_UPDATE",
		userType,
		token
	};
};

// ===================================================================================
//  PASSWORD REQUEST
// ===================================================================================
export const passwordRequestLoading = () => {
	return {
		type: "PASSWORD_REQUEST_LOADING"
	};
};

export const passwordRequestError = err => {
	return {
		type: "PASSWORD_REQUEST_ERROR",
		err
	};
};

export const passwordRequestSuccess = payload => {
	return {
		type: "PASSWORD_REQUEST_SUCCESS",
		payload
	};
};

export function passwordRequest(email) {
	return (dispatch, getState) => {
		dispatch(passwordRequestLoading());

		dispatch(getNonce("customer/request-password"))
			.then(nonce => {
				const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + nonce };
				const params = {
					email: email
				};

				return axios
					.post(REACT_APP_API_URL + "customer/request-password", params, {
						headers: AUTH_HEADER
					})
					.then(response => {
						// console.log(response)
						if (response.data.status !== 200) {
							dispatch(passwordRequestError(response.data.errors));
							return;
						}

						dispatch(passwordRequestSuccess(response));
					});
			})
			.catch(err => {
				dispatch(passwordRequestError({ general: err }));
			});
	};
}

export function getNonce(endpoint) {
	return (dispatch, getState) => {
		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY };
		const params = {
			endpoint: endpoint
		};

		return axios
			.get(REACT_APP_API_URL + "nonce", { headers: AUTH_HEADER, params: params })
			.then(response => {
				if (response.data.status !== 200) {
					return Promise.reject(response.data.message);
				}

				return Promise.resolve(response.data.nonce);
			});
	};
}

// ===================================================================================
//  CREATE ACCOUNT
// ===================================================================================
export const createAccountLoading = () => {
	return {
		type: "CREATE_ACCOUNT_LOADING"
	};
};

export const createAccountError = err => {
	return {
		type: "CREATE_ACCOUNT_ERROR",
		err
	};
};

export const createAccountSuccess = payload => {
	return {
		type: "CREATE_ACCOUNT_SUCCESS",
		payload
	};
};

export const updateAccountSuccess = customer => {
	return {
		type: "UPDATE_CUSTOMER_ACCOUNT_SUCCESS",
		customer
	};
};

export function createAccount(customer) {
	return (dispatch, getState) => {
		dispatch(createAccountLoading());

		// Determine if updating or creating
		const endpoint = customer.id ? "update" : "create";

		// Pass in customer token if updating (since they must be logged in)
		let AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY };
		if (customer.id) {
			AUTH_HEADER.Authorization += ":Bearer " + getState().user.customer.token;
		}

		// Format the address2 field name.  Lines are crossed somewhere, who cares for now.
		// console.log(customer.address2)
		if (customer.address2 !== undefined) {
			customer.address_2 = customer.address2;
		}

		return axios
			.post(REACT_APP_API_URL + "customer/" + endpoint, customer, { headers: AUTH_HEADER })
			.then(response => {
				if (!isEmpty(response.data.errors)) {
					dispatch(createAccountError(response.data.errors));
					return;

					// Error status
				} else if (!!response.data.status && response.data.status !== 200) {
					// Log user out if token expired, token, etc
					if (response.data.status === 403) {
						dispatch(userLogout("customer"));
					}

					dispatch(createAccountError({ general: response.data.message }));

					// SUCCESS
				} else {
					if (customer.id) {
						dispatch(updateAccountSuccess(response.data.formatted_values));
					} else {
						dispatch(createAccountSuccess(response.data));
					}
				}
			})
			.catch(err => {
				dispatch(createAccountError({ general: err }));
			});
	};
}

// ===================================================================================
//  CHANGE PASSWORD
// ===================================================================================
export const passwordUpdateLoading = () => {
	return {
		type: "PASSWORD_UPDATE_LOADING"
	};
};

export const passwordUpdateError = err => {
	return {
		type: "PASSWORD_UPDATE_ERROR",
		err
	};
};

export const passwordUpdateSuccess = payload => {
	return {
		type: "PASSWORD_UPDATE_SUCCESS",
		payload
	};
};

export const passwordUpdateClearErrors = () => {
	return {
		type: "PASSWORD_UPDATE_CLEAR_ERRORS"
	};
};

export function updateCustomerPassword(data) {
	return (dispatch, getState) => {
		dispatch(passwordUpdateLoading());

		const token = getState().user.customer.token;
		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };

		return axios
			.post(REACT_APP_API_URL + "customer/update-password", data, { headers: AUTH_HEADER })
			.then(response => {
				// console.log(response)
				if (response.data.status !== 200) {
					dispatch(passwordUpdateError(response.data.errors));
					return;
				}

				dispatch(passwordUpdateSuccess(response));
			})
			.catch(err => {
				dispatch(passwordUpdateError({ general: err }));
			});
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/user.js